import type { Value, TElement } from 'platejs';

import { IContentJSON } from 'common/components/ContentEditor/types';

import { convertJSON } from './convertJSON';

export const deserializeContent = (content?: string): Value | undefined => {
    let nodes = content ? JSON.parse(content) : [];

    if (Array.isArray(nodes)) {
        if (!nodes.length) return;

        return nodes as Value;
    }

    if (Object.keys(nodes).length === 0) {
        return;
    }

    nodes = convertJSON((nodes as IContentJSON).document);

    return !Array.isArray(nodes) ? [nodes as TElement] : (nodes as Value);
};
